import React, { useEffect, useState, memo, useRef } from 'react';
import { IMenuData } from '@/entity/module/home/home';
import styles from './index.less';
interface IDlMenu {
  data: Array<IMenuData>;
  value: Array<string | number>;
  onChange: (x: IMenuData) => void;
}
const DlMenu = function (props: IDlMenu): JSX.Element {
  // 默认选中的 区域
  const [district, setDistrict] = useState<IMenuData>(props.data[0]);
  // 默认选中的 商圈
  const [business, setBusiness] = useState<IMenuData | null>(null);
  useEffect(() => {
    // console.log(district,business,props.value)
    if (props.value) {
      const first = props.value[0]; // disctictId
      const second = props.value[1]; // busIs
      if (first) {
        const item = props.data.find((i) => i.value === first);
        item && setDistrict(item);
      }
      if (second) {
        console.log(props.data);

        const item = props.data.find((i) => i.value === first);
        const bus = item ? item.children.find((i) => i.value === second) : null;
        bus && setBusiness(bus);
        // console.log('second', item, bus);
      }
    }
  }, []);

  const changeBusiness = function (item: IMenuData) {
    setBusiness(item);
    props.onChange && props.onChange(item);
  };
  const dfMenuRef = useRef();
  return (
    <div className={styles.dfMenu}>
      <div className={`${styles.left} ${styles.content}`}>
        {props.data.map((item, idx) => (
          <div
            className={`${styles.item} ${district.value === item.value ? styles.active : ''}`}
            key={idx}
            onClick={() => setDistrict(item)}
          >
            <span>{item.label}</span>
            <i>{item.cinemaCount}</i>
          </div>
        ))}
      </div>
      <div className={`${styles.right} ${styles.content}`}>
        {district.children.map((item, idx) => (
          <div
            className={`${styles.item} ${styles.rightitem} ${business && business.value === item.value ? styles.active : ''
            }`}
            key={idx}
            onClick={() => changeBusiness(item)}
          >
            <span>{item.label}</span>
            <i>{item.cinemaCount}</i>
          </div>
        ))}
      </div>
    </div>
  );
};
export default memo(DlMenu);


